"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, ViewChild, } from '@angular/core';
import { FormControl } from '@angular/forms';
var InputComponent = (function () {
    function InputComponent() {
        this.type = 'text';
        this.size = 'mid';
        this.leftIconSize = 'mid';
        this.leftIconColor = 'inherit';
        this.hasError = false;
        // We need a default value to FormControl so an input can
        // still work without a FormControl specified.
        // If only we have object props spreading or FormControl
        // accepts undefined and just removes the assignment...
        this.control = new FormControl();
        this.input = new EventEmitter();
        this.click = new EventEmitter();
        this.focus = new EventEmitter();
        this.blur = new EventEmitter();
        this.keypress = new EventEmitter();
    }
    Object.defineProperty(InputComponent.prototype, "disabled", {
        set: function (value) {
            this.attrDisabled = value ? true : undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputComponent.prototype, "readonly", {
        set: function (value) {
            this.attrReadonly = value ? true : undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputComponent.prototype, "value", {
        get: function () {
            return this.nativeElement.nativeElement.value;
        },
        set: function (value) {
            this.attrValue = value;
        },
        enumerable: true,
        configurable: true
    });
    InputComponent.prototype.nativeElementOnFocus = function (event) {
        this.attrFocus = true;
        this.focus.emit(event);
    };
    InputComponent.prototype.nativeElementOnBlur = function (event) {
        this.attrFocus = undefined;
        this.blur.emit(event);
    };
    InputComponent.prototype.nativeElementOnInput = function (event) {
        this.input.emit(event);
    };
    InputComponent.prototype.nativeElementOnClick = function (event) {
        this.click.emit(event);
    };
    InputComponent.prototype.nativeElementOnKeypress = function (event) {
        this.keypress.emit(event);
    };
    __decorate([
        ViewChild('nativeElement'),
        __metadata("design:type", ElementRef)
    ], InputComponent.prototype, "nativeElement", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], InputComponent.prototype, "type", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], InputComponent.prototype, "placeholder", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], InputComponent.prototype, "disabled", null);
    __decorate([
        Input(),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], InputComponent.prototype, "readonly", null);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], InputComponent.prototype, "size", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], InputComponent.prototype, "value", null);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], InputComponent.prototype, "iconStart", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], InputComponent.prototype, "iconEnd", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], InputComponent.prototype, "leftIconSize", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], InputComponent.prototype, "leftIconColor", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], InputComponent.prototype, "hasError", void 0);
    __decorate([
        Input(),
        __metadata("design:type", FormControl)
    ], InputComponent.prototype, "control", void 0);
    __decorate([
        Output(),
        __metadata("design:type", Object)
    ], InputComponent.prototype, "input", void 0);
    __decorate([
        Output(),
        __metadata("design:type", Object)
    ], InputComponent.prototype, "click", void 0);
    __decorate([
        Output(),
        __metadata("design:type", Object)
    ], InputComponent.prototype, "focus", void 0);
    __decorate([
        Output(),
        __metadata("design:type", Object)
    ], InputComponent.prototype, "blur", void 0);
    __decorate([
        Output(),
        __metadata("design:type", Object)
    ], InputComponent.prototype, "keypress", void 0);
    InputComponent = __decorate([
        Component({
            selector: 'fl-input',
            template: "\n    <div\n      class=\"InputContainer\"\n      [ngClass]=\"{ Error: hasError }\"\n      [attr.data-focus]=\"attrFocus\"\n      [attr.disabled]=\"disabled\"\n      [attr.data-size]=\"size\"\n    >\n      <fl-icon *ngIf=\"iconStart\"\n        class=\"IconStart\"\n        [size]=\"leftIconSize\"\n        [color]=\"leftIconColor\"\n        [name]=\"iconStart\"\n      ></fl-icon>\n      <input #nativeElement\n        class=\"NativeElement\"\n        [attr.type]=\"type\"\n        [attr.placeholder]=\"placeholder\"\n        [attr.disabled]=\"attrDisabled\"\n        [attr.readonly]=\"attrReadonly\"\n        [attr.value]=\"value\"\n        [formControl]=\"control\"\n        (click)=\"nativeElementOnClick($event)\"\n        (input)=\"nativeElementOnInput($event)\"\n        (focus)=\"nativeElementOnFocus($event)\"\n        (blur)=\"nativeElementOnBlur($event)\"\n        (keypress)=\"nativeElementOnKeypress($event)\"\n      >\n      <fl-icon *ngIf=\"iconEnd\"\n        class=\"IconEnd\"\n        [name]=\"iconEnd\"\n      ></fl-icon>\n    </div>\n  ",
            styleUrls: ['./input.component.scss'],
            changeDetection: ChangeDetectionStrategy.OnPush,
        })
    ], InputComponent);
    return InputComponent;
}());
export { InputComponent };



// WEBPACK FOOTER //
// input.component.js